/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import I18n from 'I18n';
import { Map as ImmutableMap } from 'immutable';
import TemplateSettingsBufferApi from '../api/TemplateSettingsBuffer';
import { ERROR_TYPES } from '../constants/ApiErrorConstants';
import { THEME_SETTINGS_KEY, THEME_TYPE_SETTING_KEY_PATH } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import { validateAll } from '../utils/templateSettingsValuesAndValidationUtils';
import * as ActionTypes from './ActionTypes';
import { showErrorNotification, showSuccessNotification, showTemplateSettingsPublishSuccessNotification } from './Notifications';
import { templatePreviewHideLoadingOverlay, templatePreviewShowLoadingOverlay, templatePreviewTriggerIFrameReload, updateTemplateEditorForm } from './TemplateEditorActions';
function templateSettingsRequesting() {
  return {
    type: ActionTypes.FETCH_TEMPLATE_SETTINGS_PENDING
  };
}
function templateSettingsReceived(payload) {
  return {
    type: ActionTypes.FETCH_TEMPLATE_SETTINGS_SUCCESS,
    payload
  };
}
function templateSettingsRequestFailed(error) {
  return {
    type: ActionTypes.FETCH_TEMPLATE_SETTINGS_ERROR,
    error
  };
}
export function getTemplateSettings(knowledgeBaseId) {
  return dispatch => {
    dispatch(templateSettingsRequesting());
    TemplateSettingsBufferApi.get(knowledgeBaseId).then(response => dispatch(templateSettingsReceived(response)), error => {
      dispatch(templateSettingsRequestFailed(error));
      dispatch(showErrorNotification('getTemplateSettings'));
    });
  };
}
function templateSettingsUpdating() {
  return {
    type: ActionTypes.UPDATE_TEMPLATE_SETTINGS_PENDING
  };
}
function templateSettingsUpdated(payload) {
  return {
    type: ActionTypes.UPDATE_TEMPLATE_SETTINGS_SUCCESS,
    payload
  };
}
function templateSettingsUpdateFailed(error) {
  return {
    type: ActionTypes.UPDATE_TEMPLATE_SETTINGS_ERROR,
    error
  };
}
function getUpdatedTemplateSettings({
  templateSettings
}, changes) {
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  const updatedTemplateSettings = new ImmutableMap().withMutations(s => {
    changes.forEach(({
      keyPath,
      value
    }) => {
      s.setIn(keyPath, value);
    });
  });
  if (updatedTemplateSettings.has(THEME_SETTINGS_KEY)) {
    return updatedTemplateSettings.updateIn([THEME_SETTINGS_KEY], val => templateSettings.get(THEME_SETTINGS_KEY).merge(val)).toJS();
  }
  return updatedTemplateSettings.toJS();
}
export function updateTemplateSettings(knowledgeBaseId, updateData = {}) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'changes' does not exist on type '{}'.
  const {
    changes = []
  } = updateData;
  return (dispatch, getState) => {
    const state = getState();
    const updatedTemplateSettings = getUpdatedTemplateSettings(state, changes);
    const shouldReloadPreview = state.templateEditorReloadPreviewOnSave === true;
    dispatch(templateSettingsUpdating());
    if (shouldReloadPreview) {
      dispatch(templatePreviewShowLoadingOverlay());
    }
    return TemplateSettingsBufferApi.update(knowledgeBaseId, updatedTemplateSettings.knowledgeBaseSettings, updatedTemplateSettings.themeSettings).then(response => {
      dispatch(templateSettingsUpdated(response));
      if (shouldReloadPreview) {
        dispatch(templatePreviewTriggerIFrameReload());
      }
    }, error => {
      dispatch(templatePreviewHideLoadingOverlay());
      dispatch(templateSettingsUpdateFailed(error));
      dispatch(showErrorNotification('updateTemplateSettings'));
    });
  };
}
export function updateTemplateType(knowledgeBaseId, templateSettings, newTemplateType, shouldShowSuccessNotification = false) {
  const changes = [{
    keyPath: THEME_TYPE_SETTING_KEY_PATH,
    value: newTemplateType
  }];
  const oldTemplateType = templateSettings.getIn(THEME_TYPE_SETTING_KEY_PATH);
  return (dispatch, getState) => {
    const state = getState();
    const updatedTemplateSettings = getUpdatedTemplateSettings(state, changes);
    dispatch(templateSettingsUpdating());
    return TemplateSettingsBufferApi.update(knowledgeBaseId, updatedTemplateSettings.knowledgeBaseSettings, updatedTemplateSettings.themeSettings).then(response => {
      dispatch(updateTemplateEditorForm({
        changes
      }));
      dispatch(templateSettingsUpdated(response));
      dispatch(templatePreviewShowLoadingOverlay());
      dispatch(templatePreviewTriggerIFrameReload());
      if (shouldShowSuccessNotification) {
        dispatch(showSuccessNotification('updateTemplateType', {
          oldTemplateType: I18n.text(`knowledgeContentUI.chooseTemplate.templates.${oldTemplateType}.title`),
          newTemplateType: I18n.text(`knowledgeContentUI.chooseTemplate.templates.${newTemplateType}.title`)
        }));
      }
    }, error => {
      dispatch(templatePreviewHideLoadingOverlay());
      dispatch(templateSettingsUpdateFailed(error));
      dispatch(showErrorNotification('updateTemplateType'));
    });
  };
}
function templateSettingsPublishPending() {
  return {
    type: ActionTypes.TEMPLATE_EDITOR_PUBLISH_PENDING
  };
}
function templateSettingsPublishSuccess() {
  return {
    type: ActionTypes.TEMPLATE_EDITOR_PUBLISH_SUCCESS
  };
}
function templateSettingsPublishError(error) {
  return {
    type: ActionTypes.TEMPLATE_EDITOR_PUBLISH_ERROR,
    error
  };
}
export function publishTemplateSettings(knowledgeBaseId, liveKnowledgeBaseUrl) {
  return dispatch => {
    dispatch(templateSettingsPublishPending());
    return TemplateSettingsBufferApi.publish(knowledgeBaseId).then(() => {
      dispatch(templateSettingsPublishSuccess());
      dispatch(showTemplateSettingsPublishSuccessNotification('templateSettingsPublished', liveKnowledgeBaseUrl));
    }, error => {
      dispatch(templateSettingsPublishError(error));
      dispatch(showErrorNotification('templateSettingsPublished'));
    });
  };
}
export function updateHomepageCategory(knowledgeBaseId, homepageCategory) {
  return (dispatch, getState) => {
    const {
      templateEditorReloadPreviewOnSave
    } = getState();
    const shouldReloadPreview = templateEditorReloadPreviewOnSave === true;
    dispatch(templateSettingsUpdating());
    if (shouldReloadPreview) {
      dispatch(templatePreviewShowLoadingOverlay());
    }
    return TemplateSettingsBufferApi.updateKnowledgeHomepageCategory(homepageCategory, knowledgeBaseId).then(response => {
      dispatch(templateSettingsUpdated(response));
      if (shouldReloadPreview) {
        dispatch(templatePreviewTriggerIFrameReload());
      }
    }, error => {
      dispatch(templatePreviewHideLoadingOverlay());
      dispatch(templateSettingsUpdateFailed(error));
      if (error.responseJSON && ERROR_TYPES.HOMEPAGE_CATEGORY_CONFLICT_ERROR_TYPES.includes(error.responseJSON.errorType)) {
        dispatch(showErrorNotification(`updateHomepageOrganizationCategoryBuffer.${error.responseJSON.errorType}`));
      } else {
        dispatch(showErrorNotification('updateHomepageOrganizationCategoryBuffer.DEFAULT'));
      }
    });
  };
}
export function validateTemplateSettings(templateSettings) {
  return dispatch => {
    dispatch({
      type: ActionTypes.VALIDATE_TEMPLATE_SETTINGS,
      payload: {
        errors: validateAll(templateSettings)
      }
    });
  };
}